module.exports = __webpack_public_path__ + "img/Woveon3.568fbd06.jpg";